import { Component } from '@angular/core';
import { LayoutSelectors } from '@gestor-web/@core/store/selectors';
import { Store } from '@ngrx/store';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';

/**
 * @deprecated Não está mais sendo usado.
 */
@Component({
    selector: 'app-breadcrumb',
    template: `
    <div class="layout-breadcrumb-container flex justify-content-between align-items-center">
      @if (breadcrumb$ | async; as breadcrumb) {
        <p-breadcrumb
          [model]="breadcrumb.items"
          [home]="breadcrumb.home"
          styleClass="layout-breadcrumb pl-5 py-2"
        ></p-breadcrumb>
      }
      <div class="layout-breadcrumb-buttons">&nbsp;</div>
    </div>
    `,
    standalone: false
})
export class AppBreadcrumbComponent {
  breadcrumb$: Observable<{ items: MenuItem[]; home: MenuItem }>;

  constructor(private store: Store) {
    // this.breadcrumb$ = this.store.select(LayoutSelectors.selectLayoutBreadcrumb);
  }
}
